import { render, staticRenderFns } from "./SwiperSlide.vue?vue&type=template&id=068d3bf2"
import script from "./SwiperSlide.vue?vue&type=script&lang=js"
export * from "./SwiperSlide.vue?vue&type=script&lang=js"
import style0 from "./SwiperSlide.vue?vue&type=style&index=0&id=068d3bf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports